<template>
  <div>
    <nav-bar :title="'Tips'"></nav-bar>
    <div class="atm-desktop-max-width mobile py-4">
      <div role="tablist" class="mt-3">
        <tip-collapse-item
          v-for="(tip, index) in tips"
          :key="tip.id"
          :name="tip.name"
          :collapse-key="index + tip.id"
          :description="tip.description"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getTips } from '../services';
import { NavBar } from '@/common/components';
import TipCollapseItem from '../components/tips/TipCollapseItem.vue';
export default {
  components: {
    NavBar,
    TipCollapseItem,
  },
  data() {
    return {
      tips: [],
    };
  },
  async mounted() {
    try {
      this.tips = await getTips();
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
<style scoped>
a#accordion {
  color: #fff !important;
}
</style>

